import type { StepDef } from "./types";
import type { SelectOption } from "@/components/forms";

/**
 * The seven stages of the candidate application, in order. Shared by the
 * container (validation/gating) and the rail (display) so they never drift.
 */
export const APPLICATION_STEPS: StepDef[] = [
  { id: 1, title: "Resume", description: "Drop it in and we auto-fill the rest" },
  { id: 2, title: "Contact", description: "How the team reaches you" },
  { id: 3, title: "Profile", description: "Your pitch for this role" },
  { id: 4, title: "Experience", description: "Where you've made an impact" },
  { id: 5, title: "Education", description: "Academic background" },
  { id: 6, title: "Skills & Credentials", description: "Prove the expertise" },
  { id: 7, title: "Review", description: "One last look before you send" },
];

export const PHONE_CODES: SelectOption[] = [
  { value: "+1-US", label: "🇺🇸 +1 (US)" },
  { value: "+1-CA", label: "🇨🇦 +1 (CA)" },
  { value: "+44", label: "🇬🇧 +44 (UK)" },
  { value: "+61", label: "🇦🇺 +61 (AU)" },
  { value: "+49", label: "🇩🇪 +49 (DE)" },
  { value: "+33", label: "🇫🇷 +33 (FR)" },
  { value: "+81", label: "🇯🇵 +81 (JP)" },
  { value: "+91", label: "🇮🇳 +91 (IN)" },
  { value: "+86", label: "🇨🇳 +86 (CN)" },
  { value: "+55", label: "🇧🇷 +55 (BR)" },
  { value: "+52", label: "🇲🇽 +52 (MX)" },
  { value: "+63", label: "🇵🇭 +63 (PH)" },
  { value: "+65", label: "🇸🇬 +65 (SG)" },
  { value: "+82", label: "🇰🇷 +82 (KR)" },
  { value: "+31", label: "🇳🇱 +31 (NL)" },
  { value: "+46", label: "🇸🇪 +46 (SE)" },
  { value: "+41", label: "🇨🇭 +41 (CH)" },
  { value: "+34", label: "🇪🇸 +34 (ES)" },
  { value: "+39", label: "🇮🇹 +39 (IT)" },
  { value: "+7", label: "🇷🇺 +7 (RU)" },
  { value: "+27", label: "🇿🇦 +27 (ZA)" },
  { value: "+971", label: "🇦🇪 +971 (AE)" },
  { value: "+966", label: "🇸🇦 +966 (SA)" },
];

export const COUNTRIES: SelectOption[] = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Germany",
  "France",
  "Japan",
  "India",
  "China",
  "Brazil",
  "Mexico",
  "Philippines",
  "Singapore",
  "South Korea",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Spain",
  "Italy",
  "Other",
].map((c) => ({ value: c, label: c }));

export const CURRENCIES: SelectOption[] = [
  { value: "USD", label: "USD ($)" },
  { value: "CAD", label: "CAD (C$)" },
];
